import styled from 'styled-components';

const H4 = styled.h4`
	font-size: 1.6rem;
	font-weight: 600;
	margin: 0 0 0.5rem;
	line-height: 1.2;

	@media (min-width: 992px) {
		font-size: 1.8rem;
	}
`;

export default H4;
